import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_RET018_Request,
  IAPI_RET018_Response,
} from "../../../type/apiType";

// 受領者変更更新API
const httpAPI_RET018 = async (
  param: IAPI_RET018_Request
): Promise<IAPI_RET018_Response> => {
  let res = await http.post(ApiUrl.API_RET018, {
    ...param,
  });
  return res.data;
};

export { httpAPI_RET018 };
